module.exports = __webpack_public_path__ + "static/media/star.48d88a85.png";